/**
 * The external dependencies.
 */
import {all, call, takeLatest} from 'redux-saga/effects';
/**
 * The internal dependencies.
 */
import request from '../../common/request';
import {emailSent, taskViewSet, workDispatcher, workPlanner, workProductionManager, workQa} from './actions';

/**
 * Start a network request to email workplanner.
 *
 * @param  {Object}    action
 * @return {Generator}
 */
export function* workerWorkPlanner(action) {
    yield call(request, {
        endpoint: 'callWorkPlanner',
        params: [],
        requestAction: action,
        receiveAction: emailSent,
    });
}

export function* workerWorkproductionmanager(action) {
    yield call(request, {
        endpoint: 'callProductionManager',
        params: [action.payload],
        requestAction: action,
        receiveAction: emailSent,
    });
}

export function* workerWorkDispatcher(action) {
    yield call(request, {
        endpoint: 'callDispatcher',
        params: [],
        requestAction: action,
        receiveAction: emailSent,
    });
}

export function* workerWorkQa(action) {
    yield call(request, {
        endpoint: 'callQa',
        params: [action.payload.task],
        requestAction: action,
        receiveAction: emailSent,
    });
}

export function* workerTaskViewSet(action) {
    yield console.log("Worker:", action);

}

/**
 * Coordinate the workers.
 *
 * @return {Generator}
 */
export default function* ContentForeman() {
    yield all([
        takeLatest(workPlanner, workerWorkPlanner),
        takeLatest(workProductionManager, workerWorkproductionmanager),
        takeLatest(workDispatcher, workerWorkDispatcher),
        takeLatest(workQa, workerWorkQa),
        takeLatest(taskViewSet, workerTaskViewSet),
    ]);
}



// WEBPACK FOOTER //
// ./src/store/task-view/effects.js